import type { PoliciesState } from 'shared/interfaces/policy.interface';

import { createSlice } from '@reduxjs/toolkit';

import {
  getPoliciesThunk,
  getPolicyThunk,
  updatePolicyThunk,
} from './policies.thunks';

const initialState: PoliciesState = {
  list: [],
  current: null,
  isGetPoliciesThunkPending: false,
  getPoliciesThunkError: null,
  isGetPolicyThunkPending: false,
  getPolicyThunkError: null,
  isUpdatePolicyThunkPending: false,
};

const policiesSlice = createSlice({
  name: 'policies',
  initialState,
  reducers: {
    removePolicyFromStore: (state) => {
      state.current = null;
    },
    setGuidingPrincipleDescription: (state, action) => {
      if (state.current) {
        state.current.guidingPrincipleDescription = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPoliciesThunk.pending, (state) => {
        state.getPoliciesThunkError = null;
        state.isGetPoliciesThunkPending = true;
      })
      .addCase(getPoliciesThunk.fulfilled, (state, action) => {
        state.list = action.payload.rows;
        state.isGetPoliciesThunkPending = false;
      })
      .addCase(getPoliciesThunk.rejected, (state, action) => {
        state.getPoliciesThunkError =
          action.error.message || 'Failed to fetch policies';
        state.isGetPoliciesThunkPending = false;
      });

    builder
      .addCase(getPolicyThunk.pending, (state) => {
        state.getPolicyThunkError = null;
        state.isGetPolicyThunkPending = true;
      })
      .addCase(getPolicyThunk.fulfilled, (state, action) => {
        state.current = action.payload;
        state.isGetPolicyThunkPending = false;
      })
      .addCase(getPolicyThunk.rejected, (state, action) => {
        state.getPolicyThunkError =
          action.error.message || 'Failed to fetch policy';
        state.isGetPolicyThunkPending = false;
      });

    builder
      .addCase(updatePolicyThunk.pending, (state) => {
        state.isUpdatePolicyThunkPending = true;
      })
      .addCase(updatePolicyThunk.fulfilled, (state, action) => {
        state.current = action.payload;
        state.isUpdatePolicyThunkPending = false;
      })
      .addCase(updatePolicyThunk.rejected, (state) => {
        state.isUpdatePolicyThunkPending = false;
      });
  },
});

export const { removePolicyFromStore, setGuidingPrincipleDescription } =
  policiesSlice.actions;

export const policiesReducer = policiesSlice.reducer;
